export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="128"
    height="128"
    fill="none"
    viewBox="0 0 129 128"
  >
    <path
      fill="#FDC221"
      d="M68.795 35.424a5.357 5.357 0 1 1-10.713 0 5.357 5.357 0 0 1 10.713 0Zm-5.356-1.808a1.808 1.808 0 1 0 0 3.616 1.808 1.808 0 0 0 0-3.616Z"
    />
    <path
      fill="#56D3DF"
      d="M43.48 27.354a5.392 5.392 0 1 1-10.785 0 5.392 5.392 0 0 1 10.784 0Zm-5.393-1.82a1.82 1.82 0 1 0 0 3.64 1.82 1.82 0 0 0 0-3.64Z"
    />
    <path
      fill="#6E56E6"
      d="M52.726 38.102a8.035 8.035 0 0 0-8.035 8.035h8.035v-8.035Z"
    />
    <path
      fill="#FDC221"
      d="M87.543 19.355a8.035 8.035 0 0 1 8.035 8.034h-8.035v-8.034Z"
    />
    <path
      fill="#56D3DF"
      d="m77.615 19.355-5.681 5.681 1.893 1.894 5.682-5.681-1.894-1.894Z"
    />
    <path
      fill="#6E56E6"
      d="M88.88 32.778h-2.677a4.009 4.009 0 0 1-2.69 3.778V35.45c0-2.212-1.8-4.012-4.012-4.012-2.211 0-4.01 1.8-4.01 4.012 0 2.211 1.799 4.01 4.01 4.01h1.095a4.008 4.008 0 0 1-3.767 2.66v2.678c3.264 0 5.984-2.353 6.565-5.45 3.115-.567 5.487-3.294 5.487-6.57ZM78.169 35.45c0-.735.598-1.333 1.333-1.333s1.333.598 1.333 1.333v1.332h-1.333a1.334 1.334 0 0 1-1.333-1.332Z"
    />
    <path
      fill="#EE399E"
      d="M56.742 16.67c0-2.211-1.8-4.01-4.01-4.01a4.016 4.016 0 0 0-4.012 4.01v1.095a4.008 4.008 0 0 1-2.659-3.767h-2.678c0 3.264 2.353 5.984 5.45 6.565.566 3.115 3.294 5.487 6.57 5.487v-2.678a4.008 4.008 0 0 1-3.778-2.69h1.106c2.212 0 4.011-1.8 4.011-4.012Zm-5.344 0c0-.735.598-1.333 1.333-1.333s1.333.598 1.333 1.333-.598 1.333-1.333 1.333h-1.333V16.67Z"
    />
    <path
      fill="#F470BD"
      d="M68.796 51.493a2.678 2.678 0 1 0 0-5.356 2.678 2.678 0 0 0 0 5.356Z"
    />
    <path
      fill="#FDC221"
      d="M68.796 16.676a2.678 2.678 0 1 0 0-5.357 2.678 2.678 0 0 0 0 5.357Z"
    />
    <path
      fill="#56D3DF"
      d="m59.976 51.953-1.894 1.894 5.681 5.681 1.894-1.894-5.681-5.681Z"
    />
    <path
      fill="#EBAB7D"
      d="M58.798 77.556c-1.864 1.347-5.054 7.84-5.054 7.84l-.164.249c-.042-4.638.365-17.912.437-22.65.035-2.381.191-6.437-3.711-6.6-2.959-.122-3.722 3.631-3.722 3.631s1.251-6.722-3.192-6.971c-4.069-.228-4.544 4.463-4.723 6.369-.047-1.052-.598-3.078-3.293-3.107-1.349-.014-2.496 1.153-3.131 2.83-.914 2.41-1.138 5.806-1.18 7.969-.184-1.583-.87-3.477-3.13-3.392-3.429.127-3.618 5.512-3.75 8.402-.162 3.549-.183 6.78-.3 10.334-.143 4.27-.328 7.377-.03 10.354l-6.634 7.124h-.001l-.04.042.003.003c-1.841 2.087.166 7.273 4.52 11.637 4.332 4.342 9.362 6.242 11.323 4.301l.004.004 6.692-7.185c.447.041.899.076 1.356.104 7.98.492 14.996-4.202 17.614-12.148 1.714-4.527 3.744-10.006 5.347-15.017 1.119-3.494-2.65-5.993-5.24-4.123Z"
    />
    <path
      fill="#C17742"
      d="M38.145 75.954h-.03a.68.68 0 0 1-.65-.708l.635-14.902c.017-.377.361-.681.708-.65a.68.68 0 0 1 .65.707l-.635 14.902a.68.68 0 0 1-.678.65ZM45.949 75.922h-.025a.679.679 0 0 1-.654-.703l.526-14.636a.679.679 0 0 1 .68-.655h.023a.679.679 0 0 1 .655.703l-.527 14.637a.679.679 0 0 1-.678.654ZM30.823 79.867h-.014a.679.679 0 0 1-.664-.694l.24-11.082a.662.662 0 0 1 .694-.664.679.679 0 0 1 .664.694l-.24 11.082a.679.679 0 0 1-.68.664Z"
    />
    <path
      fill="#A25F45"
      d="M107.105 76.583c-1.848 1.29-3.208 3.137-4.389 6.573-.177.516-.717 1.415-.726.018-.011-1.789-.583-4.278-.78-6.194-.351-3.412-1.208-14.442-1.777-18.382-.787-5.442-7.047-4.988-7.639-.608-.272-5.492-7.505-5.907-8.026-.19-1.222-4.2-6.724-3.051-7.278 1.45-.335 2.726-.026 7.717-.026 7.717-1.515-3.352-6.214-2.068-6.31 1.865-.173 7.025.004 10.75.004 10.75s.505 10.617 1.488 15.61c1.075 5.457 2.81 7.24 7.522 9.054 1.845.71 3.111.76 4.715.761l10.564 10.95.004-.004c1.943 1.857 6.931.039 11.226-4.117 4.316-4.177 6.306-9.14 4.481-11.138l.002-.002-.039-.04-.001-.001-3.792-3.931c1.512-4.668 4.198-10.842 5.972-16.195 1.109-3.344-2.627-5.737-5.195-3.946Z"
    />
    <path
      fill="#8A3E28"
      d="M99.878 87.5c-4.54-.282-9.056 2.272-11.182 6.289-.397.75.741 1.416 1.139.665 1.924-3.635 5.937-5.89 10.043-5.635.848.052.845-1.267 0-1.32ZM95.069 76.67c.847.047.845-1.272 0-1.318a47.825 47.825 0 0 0-2.08-.059c-.255-5.357-.262-10.723-.448-16.082-.03-.846-1.348-.85-1.319 0 .186 5.362.193 10.731.448 16.09a47.88 47.88 0 0 0-6.463.534c-.343-5.52-.402-11.057-.612-16.584-.032-.846-1.35-.85-1.318 0 .21 5.56.268 11.128.615 16.68.004.05.024.086.035.129a47.795 47.795 0 0 0-6.14 1.522c-.169-3.079-.465-6.148-.614-9.228-.04-.845-1.36-.85-1.319 0 .156 3.23.478 6.448.641 9.677-.423.15-.849.289-1.268.45-.784.303-.443 1.578.35 1.272a46.935 46.935 0 0 1 19.492-3.082Z"
    />
  </svg>
);
